import React, { useEffect } from "react";
import * as cls from "./modalPaymentStatus.module.scss";

function ModalPaymentStatus({ sendStatus, setSendStatus }) {
  useEffect(() => {
    if (sendStatus) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [sendStatus]);

  const handleClose = () => {
    setSendStatus(false);
  };
  if (!sendStatus) return null;
  if (sendStatus === "success")
    return (
      <div className={cls.modalOverlay}>
        <div className={cls.modalContainer}>
          <div className={cls.modalHeader}>
            <h2 className={cls.modalTitle}>Оформление квитанции</h2>
            <button className={cls.closeButton} onClick={handleClose}>
              ×
            </button>
          </div>
          <div>
            Квитанция будет выслана Вам на почту в ближайшее время.
            <div className={cls.dialogActions}>
              <button onClick={handleClose} className={cls.button_bright}>
                Закрыть
              </button>
            </div>
          </div>
        </div>
      </div>
    );
}

export default ModalPaymentStatus;
